import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainNavComponent } from '@core/components/main-nav/main-nav.component';
import { SettingsComponent } from '@shared/components/settings/settings.component';
import { LoginComponent } from '@shared/components/login/login.component';
import { GdprConsentComponent } from '@shared/components/gdpr-consent/gdpr-consent.component';
import { ResetPasswordComponent } from '@shared/components/reset-password/reset-password.component';
import { AuthGuard } from '@core/guards/auth.guard';
import { SysAdminAuthGuard } from '@core/guards/sysadmin.auth.guard';
import { CustomerAdminAuthGuard } from '@core/guards/customeradmin.auth.guard';
import { SysAdminModule } from '@xprojectorfeatures/sysadmin/sys-admin.module';
import { UserProfileComponent } from '@shared/components/user-profile/user-profile.component';
import { UserProfilesComponent } from '@shared/components/user-profiles/user-profiles.component';
import { HomeComponent } from '@core/components/home/home.component';
import { CustomerSettingsComponent } from './shared/components/customer-settings/customer-settings.component';
import { SysAdminUserProfilesComponent } from '../../../xprojector-core/features/sysadmin/components/sys-admin-user-profiles/sys-admin-user-profiles.component';
import { SysAdminUserProfileComponent } from '../../../xprojector-core/features/sysadmin/components/sys-admin-user-profile/sys-admin-user-profile.component';
import { CreateCredentialsComponent } from './shared/components/create-credentials/create-credentials.component';
import { StartMobileAppComponent } from '@shared/components/start-mobile-app/start-mobile-app.component';

import { AdminDashboardsModule } from '@xprojectorfeatures/admin-dashboards/admin-dashboards.module';
import { XConfDashboardModule } from '@xprojectorfeatures/xconf-dashboards/xconf-dashboard.module';

const sysAdminModule = () => import('@xprojectorfeatures/sysadmin/sys-admin.module').then(x => x.SysAdminModule);
const dataConfigurationModule = () => import('@xprojectorfeatures/data-configuration/data-configuration.module').then(x => x.DataConfigurationModule);
// const dashboardModule = () => import('@xprojectorfeatures/admin-dashboards/admin-dashboards.module').then(x => x.AdminDashboardsModule);
// const xconfDashboardModule = () => import('@xprojectorfeatures/xconf-dashboards/xconf-dashboard.module').then(x => x.XConfDashboardModule);
const configurationModule = () => import('@xprojectorfeatures/xconf/xconf.module').then(x => x.XconfModule);
const portalModule = () => import('@xprojectorfeatures/portal/portal.module').then(x => x.PortalModule);

const bmsAdminModule = () => import('@features/bms/bms-admin/bms-admin.module').then(x => x.BmsAdminModule);
const bmsEventsModule = () => import('@features/bms/bms-events/bms-events.module').then(x => x.BmsEventsModule);

const routes: Routes = [
  {
    path: '',
    component: MainNavComponent,
    children: [
      { path: 'adminhome', component: HomeComponent, canActivate: [SysAdminAuthGuard] },
      { path: 'start-mobile-app', component: StartMobileAppComponent },
      { path: 'login', component: LoginComponent },
      { path: 'gdprconsent', component: GdprConsentComponent },
      { path: 'resetpassword', component: ResetPasswordComponent },
      { path: 'customersettings', component: CustomerSettingsComponent, canActivate: [CustomerAdminAuthGuard] },
      { path: 'userprofile', component: UserProfileComponent, canActivate: [AuthGuard] },
      { path: 'adminuserprofile', component: SysAdminUserProfileComponent, canActivate: [SysAdminAuthGuard] },
      { path: 'userprofiles', component: UserProfilesComponent, canActivate: [CustomerAdminAuthGuard] },
      //{ path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'sysadmin', loadChildren: sysAdminModule, canActivate: [SysAdminAuthGuard] },
      { path: 'xprojector', loadChildren: dataConfigurationModule, canActivate: [AuthGuard] },
      //{ path: 'dashboard', loadChildren: dashboardModule, canActivate: [AuthGuard] },
      { path: 'dashboard', loadChildren: () => AdminDashboardsModule, canActivate: [AuthGuard] },
      //{ path: 'xconfdashboard', loadChildren: xconfDashboardModule, canActivate: [AuthGuard] },
      { path: 'xconfdashboard', loadChildren:() => XConfDashboardModule, canActivate: [AuthGuard] },
      { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
      { path: 'configuration', loadChildren: configurationModule, canActivate: [SysAdminAuthGuard] },
      { path: 'customers', loadChildren: portalModule, canActivate: [AuthGuard] },
      { path: 'createcredentials/:action', component: CreateCredentialsComponent },

      { path: 'bmsadmin', loadChildren: bmsAdminModule, canActivate: [SysAdminAuthGuard] },
      { path: 'bmsevent', loadChildren: bmsEventsModule },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
// force git to accept changes
